export default __webpack_public_path__ + "static/media/grid6mobile.73045a55.png";